import { Alert, AlertDescription, AlertIcon, AlertTitle } from '@chakra-ui/react'
import { RentalLedger } from '@homevest/types/ledger'
import { formatMoney } from 'lib/numbers'
import React, { FC } from 'react'

interface CashoutValidAlertProps {
  ledger: RentalLedger
}

const CashoutValidAlert: FC<React.PropsWithChildren<CashoutValidAlertProps>> = ({ ledger }) => {
  const outstandingWalletOrDepositBalance = Object.entries(ledger.summaries).find(
    ([_, ledgerSummary]) =>
      ['Wallet Contribution', 'Security Deposit'].includes(ledgerSummary.liabilityTypeName)
  )?.[1]?.balance

  if (!outstandingWalletOrDepositBalance) {
    return null
  }

  return (
    <Alert status='error' my={2} py={2}>
      <AlertIcon />
      <AlertTitle fontSize='sm'>Cannot cashout tenant!</AlertTitle>
      <AlertDescription fontSize='sm'>
        Please reverse the {formatMoney(outstandingWalletOrDepositBalance, 2, '$')} outstanding
        wallet or security deposit balance.
      </AlertDescription>
    </Alert>
  )
}

export default CashoutValidAlert
